export function isProviderOperationsEnabled(
	enabledFlag: string | undefined = import.meta.env.VITE_ENABLE_PROVIDER_OPERATIONS,
): boolean {
	return enabledFlag !== undefined && Number.parseInt(enabledFlag) === 1;
}
